var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBlender = function SvgBlender(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b1a41a47-21e7-4234-8af8-73ee8d835c28",
    "data-name": "Layer 1",
    viewBox: "0 0 629.4 511.2",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ba0a5d1f-d774-4f74-8c9d-2fb49e2bc08a",
    "data-name": "vlpa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.9,292.9c1.2-21,11.4-39.5,27-52.6a91.3,91.3,0,0,1,116,0c15.5,13.1,25.8,31.6,26.9,52.6s-7.5,41.6-22.7,56.4-37.5,24.6-62.2,24.6-46.8-9.5-62.3-24.6-23.9-34.9-22.7-56.4Z",
    transform: "translate(-22.8 -5.5)",
    style: {
      fill: "#265787"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.6,335.4c.1,8.2,2.7,24.2,6.7,36.6A193.2,193.2,0,0,0,264,444.4a216.1,216.1,0,0,0,73.1,52.4,238.5,238.5,0,0,0,191.9-.3,216.8,216.8,0,0,0,73-52.7,194.8,194.8,0,0,0,41.8-72.4,184.6,184.6,0,0,0,7.8-40.5,179.7,179.7,0,0,0-1.3-40.1,186.5,186.5,0,0,0-26.6-72.9,203,203,0,0,0-48.6-53.6h.1L378.6,13.3l-.6-.4c-12.9-9.9-34.5-9.8-48.7.1s-16,26.6-3.2,37.1H326l82,66.7-249.9.3h-.4c-20.6,0-40.5,13.6-44.4,30.7s10,31.9,31.4,32h0l126.7-.3L45.3,353.2l-.8.6c-21.3,16.3-28.2,43.5-14.8,60.7s42.6,17.5,64.2.1l123.3-101s-1.8,13.6-1.6,21.8Zm317,45.6c-25.4,25.9-61,40.6-99.5,40.7s-74.2-14.5-99.6-40.3a119.5,119.5,0,0,1-27.2-42.6,110.8,110.8,0,0,1-6.2-47.5,112,112,0,0,1,13.6-44.7,121.8,121.8,0,0,1,30.3-36c24.7-20.1,56.1-31,89-31.1s64.4,10.8,89.1,30.8a122.6,122.6,0,0,1,30.2,35.9,111.6,111.6,0,0,1,7.5,92.2A119.5,119.5,0,0,1,532.6,381Z",
    transform: "translate(-22.8 -5.5)",
    style: {
      fill: "#ea7600"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlender, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blender.8b7fc60e.svg";
export { ForwardRef as ReactComponent };